import React from 'react';

//Styles
import './About.scss';

//Icons
import Building from '../Icons/about/Building';
import Excavator from '../Icons/about/Excavator';
import Wrench from '../Icons/about/Wrench';
import Painter from '../Icons/about/Painter';
import Spray from '../Icons/about/Spray';
import Shield from '../Icons/about/Shield';
import Standard1 from '../Icons/about/Standard1';
import Standard2 from '../Icons/about/Standard2';
import Standard3 from '../Icons/about/Standard3';
import Standard4 from '../Icons/about/Standard4';

//SVG icons
import Dots from '../Icons/Dots';
import Square from '../Icons/Square';
import Circle from '../Icons/Circle';
import Triangle from '../Icons/Triangle';

function About() {
    return (
        <div className="aboutView">
            <div className="container">
                <div className="aboutUs section">
                    <h2>About Us <Dots /></h2>

                    <div className="container-inner">
                        <h3>GOLD CONSTRUCTION LIMITED</h3>

                        <div className="text">
                            <p>We GOLD CONSTRUCTION LIMITED, one of the growing construction company in Zambia. We have a broad portfolio of successfully completed projects across a range of sectors including Industrial, Commercial, Residential, Restoration, Refurbishment and Hospitality</p>

                            <p>We are known for our client focus and hands-on approach. We are proud of the fact that the majority of our workload comes from our existing clients and that we have a strong reputation for our competitive edge and reliable execution of all projects undertaken. This is achieved through our relentless attention to detail and an experienced team with the drive and customer focus to ensure client delight.</p>

                            <p>We continue to invest in modern business practices and management techniques

                                in order to ensure that we retain the cutting edge in our industry. We continue to scale

                                new heights with our focus firmly on growing the ability & capacity of our business is in

                                terms of Manpower or Machinery to deliver in new and innovative ways.

                                Our ambition and goals always been to deliver quality projects and value for money

                                to our clients; our success and reputation today have been testament to this

                                vision of ours.</p>

                            <p>
                                We have well developed and comfortable working atmosphere with high Tech

                                machines in Zambia's most progressive city and business hub of Lusaka, Zambia.
                            </p>

                            <p>
                                The company was incorporated in the year 2019, during our construction process each section is closely monitored through the inspection during every stage of completion. The final Inspections are under the highly experienced and qualified person. ensures that the construction meets the exact requirements.
                            </p>
                            <p><h4> Quality Turnkey Projects from Ground Zero to Custom interior and Exterior Design:</h4> At Gold Constructions Ltd. we are committed to excellent project delivery and customer satisfaction with our in-house engineering, architecture, and design departments while maintaining a commitment to safety standards of our team.

                                It is this commitment that has given us an amazing reputation in the building and design landscape around Zambia.</p>

                            <p> <h4>No Job Too Big, No Job Too Small:</h4>

                                When we started out, it was the small jobs that paid our bills. They were important then and they're important now.

                                Whatever is your requirement-pmall, large, indoor, outdoor- Gold Construction Ltd. can see to it with ease.</p>

                        </div>
                    </div>

                    <Triangle />
                    <Square />
                </div>

                <div className="whatWeDo section">
                    <h2>What we can do? <Dots /></h2>

                    <div className="container-inner">
                        <div className="card-container">
                            <div className="card">
                                <Building />
                                <p>Redesign And Refurbish Construction</p>
                            </div>

                            <div className="card">
                                <Excavator />
                                <p>Preparation of Construction Grounds and Roads.</p>
                            </div>

                            <div className="card">
                                <Wrench />
                                <p>Custom Fabrication and Installation.</p>
                            </div>

                            <div className="card">
                                <Painter />
                                <p>Waterproofing and Painting Solutions</p>
                            </div>

                            <div className="card">
                                <Spray />
                                <p>Water Features and Landscaping</p>
                            </div>

                            <div className="card">
                                <Shield />
                                <p>Exterior and Interior Design and Equipment Installations</p>
                            </div>
                        </div>
                    </div>

                    <Square />
                    <Circle />
                </div>

                <div className="ourStandards section">
                    <h2>Our standards <Dots /> </h2>

                    <div className="container-inner">
                        <div className="text">
                            <p>In all activities in the company, we take measures to limit the generation of waste, apply environmentally friendly procedures and protect life and health at work.
                            </p>
                        </div>

                        <div className="standard-container">
                            <div className="standard">
                                <Standard1 />
                                <div className="standard-text">
                                    <h4>Great services</h4>
                                    <p>You can count on the high quality of our work and adherence to agreed deadlines and prices.</p>
                                </div>
                            </div>

                            <div className="standard">
                                <Standard2 />
                                <div className="standard-text">
                                    <h4>High standards</h4>
                                    <p>When providing our services, we always try to proceed in accordance with the requirements of ISO and STN standards</p>
                                </div>
                            </div>

                            <div className="standard">
                                <Standard3 />
                                <div className="standard-text">
                                    <h4>A Team of Professionals</h4>
                                    <p>Our customers can always count on the high expertise and professionalism of our employees.</p>
                                </div>
                            </div>

                            <div className="standard">
                                <Standard4 />
                                <div className="standard-text">
                                    <h4>Creative solutions</h4>
                                    <p>Since our inception, we have implemented dozens of construction projects of various nature.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default About;